import { FuelCard } from 'dataSources/Typicode/fuelCards';
import { FuelCardsData } from 'store/features/fuelCards/types';

export const mapCardsById = (cards: FuelCard[]) => {
  return cards.reduce((acc, card) => {
    acc[card.fullNumberCard] = card;

    return acc;
  }, {} as FuelCardsData);
};
